"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const GridEmptyData_1 = require("./GridEmptyData");
const GridBodyRowAdditional = () => {
  return (0, jsx_runtime_1.jsx)(styles_1.StyledGridBodyRowMultiple, {
    children: (0, jsx_runtime_1.jsx)(styles_1.StyledGridBodyCellMultiple, {})
  });
};
const GridBodyRow = props => {
  const {
    item,
    columns,
    loading,
    active,
    visited,
    visitedRowBgColor,
    onSelectItem,
    dataAttr = '',
    onCellSelect,
    gridTemplateColumns
  } = props;
  const columnsTitles = [];
  react_1.default.Children.forEach(columns, ({
    props: properties
  }) => {
    if (properties.name.length > 0) {
      columnsTitles.push(properties.name);
    }
  });
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(styles_1.StyledGridBodyRow, {
      "aria-label": "grid-body-row",
      "data-id": item?.[dataAttr],
      gridTemplateColumns: gridTemplateColumns,
      multiple: !loading && !!item?.multiple,
      "$loading": loading,
      active: active,
      visited: visited,
      visitedRowBgColor: visitedRowBgColor,
      onClick: onSelectItem,
      className: !visited ? 'grid-body-row' : 'grid-body-row-visited',
      children: columnsTitles.map((key, i) => (0, jsx_runtime_1.jsx)(styles_1.StyledGridBodyCell, {
        "aria-label": "grid-body-cell",
        onClick: e => onCellSelect?.(key, e),
        children: (0, jsx_runtime_1.jsx)(styles_1.StyledGridBodyCellText, {
          children: loading ? (0, jsx_runtime_1.jsx)(styles_1.Skeleton, {
            height: "19px"
          }) : item?.[key]
        })
      }, `row-${i}_${key}`))
    }), !loading && item?.multiple && (0, jsx_runtime_1.jsx)(GridBodyRowAdditional, {})]
  });
};
const GridBody = props => {
  const {
    data = [],
    bgColor,
    visitedRowBgColor,
    columns,
    loading,
    emptyData,
    selectedItem,
    onSelect,
    dataAttr,
    onCellSelect,
    gridTemplateColumns
  } = props;
  if (loading) {
    return (0, jsx_runtime_1.jsx)(styles_1.StyledGridBody, {
      bgColor: bgColor,
      "aria-label": "grid-body",
      children: [...Array(10).keys()].map((item, i) => (0, jsx_runtime_1.jsx)(GridBodyRow, {
        columns: columns,
        bgColor: bgColor,
        loading: loading,
        gridTemplateColumns: gridTemplateColumns
      }, `row-${i}`))
    });
  }
  if (data.length > 0) {
    return (0, jsx_runtime_1.jsx)(styles_1.StyledGridBody, {
      bgColor: bgColor,
      "aria-label": "grid-body",
      children: data.map((item, i) => (0, jsx_runtime_1.jsx)(GridBodyRow, {
        columns: columns,
        item: item,
        bgColor: bgColor,
        visitedRowBgColor: visitedRowBgColor,
        loading: loading,
        active: item[dataAttr] === selectedItem?.[dataAttr],
        visited: item.visited,
        dataAttr: dataAttr,
        onSelectItem: e => onSelect(i, e),
        onCellSelect: (col, e) => onCellSelect?.(i, col, e),
        gridTemplateColumns: gridTemplateColumns
      }, `row-${i}`))
    });
  }
  return (0, jsx_runtime_1.jsx)(styles_1.StyledGridBody, {
    bgColor: bgColor,
    "aria-label": "grid-body",
    children: (0, jsx_runtime_1.jsx)(GridEmptyData_1.GridEmptyData, {
      emptyData: emptyData
    })
  });
};
exports.GridBody = GridBody;